<template>
  <div class="box">
    <div class="topimg">
      <img class="topimg_img" src="../../assets/home/yiyuanimg.jpg" />
    </div>
    <div class="management">
      <div>{{ patient ? '当前就诊人：' + patient : '当前就诊人：- -' }}</div>
      <div>
        <button class="management_bun" @click="jump('patientList')">
          就诊人管理
        </button>
      </div>
    </div>
    <!-- <div class="lattice">
      <div class="lattice_title">门诊就医</div>
      <div class="lattice_main">
        <div
          class="lattice_main_bor"
          v-for="(itme, index) in latticeList"
          :key="index"
          @click="jump(itme.rousers)"
        >
          <div class="lattice_main_bor_img">
            <img class="lattice_icon" :src="itme.src" />
          </div>
          <div class="lattice_main_bor_text">{{ itme.title }}</div>
        </div>
      </div>
    </div> -->

    <div class="menu">
      <div class="menu-left">
        <div class="extend" @click="jump('selectDepartment')">
          <div class="avatar"></div>
          <div class="extend-title">在线挂号</div>
          <div class="extend-item">当天挂号,预约挂号</div>
          <div class="extend-btn">
            <van-button type="info" size="normal">立即挂号</van-button>
          </div>
        </div>
        <div class="mail" @click="jump('my')">
          <div class="my-item">
            <div class="item-title">个人中心</div>
            <div class="item-detail">立即查看</div>
          </div>
          <div class="my-icon"></div>
        </div>
      </div>

      <div class="myandmail">
        <div class="my" @click="jump('list')">
          <div class="my-item">
            <div class="item-title">门诊缴费</div>
            <div class="item-detail">查看门诊缴费</div>
          </div>
          <div class="my-icon"></div>
        </div>
        <div class="result-pacs" @click="jump('resultPacsList')">
          <div class="result-item">
            <div class="item-title">检查结果</div>
            <div class="item-detail">查看报告</div>
          </div>
          <div class="result-icon"></div>
        </div>
        <div class="result-lis" @click="jump('resultLisList')">
          <div class="result-item">
            <div class="item-title">检验结果</div>
            <div class="item-detail">查看结果</div>
          </div>
          <div class="result-icon"></div>
        </div>
      </div>
    </div>
    <!-- <div class="list">
      <div class="list_title beforecss">核酸检测</div>
      <div class="list_main">
        
        <div class="list_main_box" @click="jump('nindex',3)">
          <div class="list_main_box_img">
            <img class="list_icon" src="../../assets/home/hs3.png" />
          </div>
          <div class="list_main_box_text">多人混检</div>
        </div>
        <div class="list_main_box" @click="jump('nindex',2)">
          <div class="list_main_box_img">
            <img class="list_icon" src="../../assets/home/hs.png" />
          </div>
          <div class="list_main_box_text">单人单检</div>
        </div>

        <div class="list_main_box" @click="jump('acidList')">
          <div class="list_main_box_img">
            <img class="list_icon" src="../../assets/home/hs1.png" />
          </div>
          <div class="list_main_box_text">缴费记录</div>
        </div>
      </div>
    </div> -->
    <div class="list">
      <div class="list_title beforecss">医院信息</div>
      <div class="list_main">
        <div class="list_main_box" @click="jump('docindex')">
          <div class="list_main_box_img">
            <img class="list_icon" src="../../assets/home/yishengliebiao.png" />
          </div>
          <div class="list_main_box_text">医生列表</div>
        </div>
        <div class="list_main_box" @click="jump('details')">
          <div class="list_main_box_img">
            <img class="list_icon" src="../../assets/home/yiyuanxinxi.png" />
          </div>
          <div class="list_main_box_text">医院详情</div>
        </div>
        <div class="list_main_box" @click="jump('guide')">
          <div class="list_main_box_img">
            <img class="list_icon" src="../../assets/home/shiyongbangzhu.png" />
          </div>
          <div class="list_main_box_text">使用帮助</div>
        </div>
      </div>
    </div>
    <!-- <div class="clindex" @click="clindex"></div> -->
  </div>
</template>

<script>
import { getDefaultPatient } from '@/api/api'
import { getBaseUrl } from '@/utils/request'
export default {
  props: {},
  data() {
    return {
      patient: '',
      patientId: '',
      latticeList: [
        {
          src: require('../../assets/home/gh.png'),
          rousers: 'selectDepartment',
          title: '在线挂号'
        },
        {
          src: require('../../assets/home/jf.png'),
          rousers: 'list',
          title: '门诊缴费'
        },
        {
          src: require('../../assets/home/bg.png'),
          rousers: 'no',
          title: '检查报告'
        },
        {
          src: require('../../assets/home/my.png'),
          rousers: 'my',
          title: '个人中心'
        }
      ]
    }
  },
  computed: {},
  created() {},
  mounted() {
    localStorage.removeItem('patientId')
    localStorage.removeItem('ClinicCode')
    this.getPatientData()
  },
  watch: {},
  methods: {
    jump(pash, type) {
      if (pash == 'nindex') {
        sessionStorage.setItem('type', type)
        this.$router.push(pash)
      } else if (pash == 'resultPacsList') {
        this.$router.push({
          name: 'resultPacsList',
          query: {
            patientId: this.patientId
          }
        })
      } else if (pash == 'resultLisList') {
        this.$router.push({
          name: 'resultLisList',
          query: {
            patientId: this.patientId
          }
        })
      } else {
        this.$router.push(pash)
      }
    },
    clindex() {
      this.$router.push('index2')
    },
    getPatientData() {
      getDefaultPatient().then(res => {
        if (res.code == 200) {
          if (res.data.length != 1) {
            this.patient = ''
          } else {
            this.patient = res.data[0].patientName
            this.patientId = res.data[0].patientId
          }
          this.nickName = JSON.parse(localStorage.getItem('userItem')).nickName
          this.headImg = JSON.parse(localStorage.getItem('userItem')).headImgUrl
        }
      })
    }
  },
  components: {}
}
</script>

<style scoped lang="scss">
.box {
  margin-bottom: 50px;
}

.topimg {
  width: 100vw;
}

.topimg_img {
  width: 100vw;
}

/* */
.management {
  margin: 10px 10px 10px 10px;
  height: 60px;
  border: 1px solid #e7e4e4;
  border-radius: 100px;
  box-shadow: 1px 1px 5px 1px #e7e4e4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
  font-size: 18px;
}

.management_bun {
  padding: 5px 8px 5px 8px;
  background-color: rgb(254, 185, 88);
  border: 1px solid rgb(254, 185, 88);
  border-radius: 5px;
  color: #ffffff;
}

/* */
.lattice {
  margin: 13px 10px 10px 10px;
}

.lattice_title {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 5px;
}

.lattice_title:before {
  width: 3.5px;
  height: 19px;
  background-color: rgb(245, 155, 120);
  content: '.';
  color: rgb(245, 155, 120);
  margin-right: 10px;
  display: inline-block;
}

.lattice_main {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 10px;
}

.lattice_main_bor {
  display: flex;
  align-items: center;
  border: 1px solid rgb(230, 227, 227);
  width: 47.5%;
  height: 80px;
  margin-bottom: 10px;
  box-shadow: 1px 1px 5px 1px #e7e4e4;
  border-radius: 4px;
}

.lattice_main_bor_img {
  width: 50px;
  height: 50px;
  border-radius: 100px;
  margin-left: 13px;
}

.lattice_icon {
  width: 50px;
  height: 50px;
}

.lattice_main_bor_text {
  font-size: 16px;
  margin-left: 15px;
}

/* */
.list {
  margin: 13px 10px 10px 10px;
  font-size: 18px;
}

.list_title {
  font-weight: 500;
  letter-spacing: 5px;
}

.beforecss:before {
  width: 3.5px;
  height: 19px;
  background-color: rgb(39, 183, 206);
  content: '.';
  color: rgb(39, 183, 206);
  margin-right: 10px;
  display: inline-block;
}

.list_main {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
}

.list_main_box {
  width: 25%;
}

.list_main_box_img {
  border-radius: 90px;
  display: flex;
  justify-content: center;
}

.list_icon {
  width: 50px;
  height: 50px;
}

.list_main_box_text {
  text-align: center;
  margin-top: 5px;
}

.clindex {
  width: 20px;
  height: 20px;
  background-color: #ffffff;
}

.menu {
  background: #fff;
  margin: 15px 10px;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  padding: 10px;
  height: 310px;
  display: flex;
  justify-content: space-between;

  .menu-left {
    width: 43%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    .extend {
      width: 100%;
      background: rgb(244, 247, 255);
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 10px 0;

      .avatar {
        width: 60px;
        height: 60px;
        background-image: url('../../assets/home/gh.png');
        background-size: 100% 100%;
      }

      .extend-title {
        font-size: 18px;
        color: #000;
        margin-top: 5px;
      }

      .extend-item {
        color: #949494;
        margin-top: 10px;
        display: flex;

        .colorred {
          color: red;
        }
      }

      .extend-btn {
        margin-top: 10px;
      }
      .extend-btn button {
        font-size: 18px;
      }
    }

    .mail {
      width: 100%;
      height: 30%;
      background: rgb(253, 249, 238);
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      padding: 10px 0;

      .my-item {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .item-title {
          color: #000;
          display: flex;
          justify-content: center;
          font-size: 18px;
        }

        .item-detail {
          color: #969696;
          width: 100%;
          display: flex;
          justify-content: center;
          font-size: 16px;
          margin-top: 2px;
        }
      }

      .my-icon {
        width: 50px;
        height: 50px;
        background-image: url('../../assets/home/my.png');
        background-size: 100% 100%;
        background-position: center;
      }
    }
  }

  .myandmail {
    width: 54%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .my {
      width: 100%;
      height: 33%;
      padding: 18px 15px;
      display: flex;
      align-items: center;
      background: rgb(241, 250, 249);

      .my-item {
        width: calc(100% - 50px);
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .item-title {
          color: #000;
          width: 100%;
          display: flex;
          font-size: 18px;
          justify-content: center;
        }

        .item-detail {
          color: #969696;
          width: 100%;
          display: flex;
          justify-content: center;
          font-size: 16px;
          margin-top: 2px;
        }
      }

      .my-icon {
        width: 50px;
        height: 50px;
        background-image: url('../../assets/home/jf.png');
        background-size: 100% 100%;
      }
    }

    .result-pacs {
      width: 100%;
      padding: 18px 15px;
      display: flex;
      background: #f0ebfc;

      .result-icon {
        width: 50px;
        height: 50px;
        background-image: url('../../assets/home/v1.png');
        background-size: 100% 100%;
      }
    }

    .result-lis {
      width: 100%;
      padding: 18px 15px;
      display: flex;
      background: #ebf8df;

      .result-icon {
        width: 50px;
        height: 50px;
        background-image: url('../../assets/home/v2.png');
        background-size: 100% 100%;
      }
    }
  }
}
.result-item {
  width: calc(100% - 50px);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .item-title {
    color: #000;
    width: 100%;
    display: flex;
    font-size: 18px;
    justify-content: center;
  }

  .item-detail {
    color: #969696;
    width: 100%;
    display: flex;
    justify-content: center;
    font-size: 16px;
    margin-top: 2px;
  }
}
</style>
